import { INDRACurrency } from '@ibe.models/calendar-price.indra.model.lib';
import { SESSION_VAR_KEY_CURRENCY, CURRENCIES_SYMBOLS, SESSION_VAR_KEY_MARKET, DEFAULT_DECIMAL_PLACES } from '@ibe.config';
import { getCurrencySymbol } from '@angular/common';
import * as i0 from "@angular/core";
var INDRACurrencyService = /** @class */ (function () {
    function INDRACurrencyService() {
    }
    // get currency symbol based on stored currency
    INDRACurrencyService.prototype.INDRA_getCurrencySymbol = function (currency) {
        var storedCurrency = currency ? currency : sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY);
        return {
            name: storedCurrency,
            unit: CURRENCIES_SYMBOLS[storedCurrency] && CURRENCIES_SYMBOLS[storedCurrency].currencySymbol ? CURRENCIES_SYMBOLS[storedCurrency].currencySymbol : storedCurrency,
            highlightSymbol: CURRENCIES_SYMBOLS[storedCurrency] && CURRENCIES_SYMBOLS[storedCurrency].highlightSymbol ? CURRENCIES_SYMBOLS[storedCurrency].highlightSymbol :
                CURRENCIES_SYMBOLS.dollar.highlightDollar.includes(storedCurrency) ? CURRENCIES_SYMBOLS.dollar.currencySymbol : getCurrencySymbol(storedCurrency, 'narrow', 'pt-PT')
        };
    };
    INDRACurrencyService.prototype.INDRA_getCurrency = function () {
        var storedCurrency = sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY);
        return storedCurrency;
    };
    INDRACurrencyService.prototype.INDRA_getPrice = function (ammount, priceUnit) {
        if (ammount) {
            return priceUnit === 'cash' ?
                ammount.currency.value ? this.INDRA_formatCash(ammount.currency.value) + " " + ammount.currency.unit : '' :
                ammount.points ? this.INDRA_formatMiles(ammount.points) + " M" : '';
        }
        else {
            return '';
        }
    };
    INDRACurrencyService.prototype.INDRA_formatCash = function (price, locale) {
        var market = locale ? locale : sessionStorage.getItem(SESSION_VAR_KEY_MARKET);
        var sessionDecimals = sessionStorage.getItem('decimals');
        var decimals = sessionDecimals ? isNaN(+sessionDecimals) ? DEFAULT_DECIMAL_PLACES : +sessionDecimals : DEFAULT_DECIMAL_PLACES;
        return (+price).toLocaleString(market, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
    };
    INDRACurrencyService.prototype.INDRA_formatMiles = function (price, locale) {
        var market = locale ? locale : sessionStorage.getItem(SESSION_VAR_KEY_MARKET);
        return (+price.toFixed(0)).toLocaleString(market);
    };
    INDRACurrencyService.prototype.INDRA_formatNumber = function (value, locale) {
        var market = locale ? locale : sessionStorage.getItem(SESSION_VAR_KEY_MARKET);
        return (+value).toLocaleString(market, { minimumFractionDigits: 0, maximumFractionDigits: 15 });
    };
    INDRACurrencyService.prototype.INDRA_getDecimalPlaces = function () {
        var sessionDecimals = sessionStorage.getItem('decimals');
        var decimals = sessionDecimals ? isNaN(+sessionDecimals) ? DEFAULT_DECIMAL_PLACES : +sessionDecimals : DEFAULT_DECIMAL_PLACES;
        return decimals;
    };
    INDRACurrencyService.ngInjectableDef = i0.defineInjectable({ factory: function INDRACurrencyService_Factory() { return new INDRACurrencyService(); }, token: INDRACurrencyService, providedIn: "root" });
    return INDRACurrencyService;
}());
export { INDRACurrencyService };
